import React from 'react'
import { logo } from '../../../constants.json'
const Logotype = ({ width, height, className }) => {
  return (
    <img
      src={logo}
      alt="logotype"
      width={width}
      height={height}
      className={className}
    />
  )
}

export default Logotype
